module.exports = __webpack_public_path__ + "img/content_title_pc.de37d603.svg";